import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputLabel,
  Paper,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
  FormControl,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  approve_organisation_paymentRequest,
  get_all_organisations,
  get_organisation_payment_request,
  get_payment_receipt,
  getAvailableAccess,
} from "../Redux/Actions/action";
import ErrorHandler, { CommonChip } from "../Utils/handler";
import { showLoader } from "../Redux/Slices/loaderSlice";
import { toast } from "react-toastify";
import CommonSearchField from "../Components/Common/CommonSearchField";
import CommonTable from "../Components/Common/CommonTable";
import StyledTableCell from "../Components/Common/styledTableCell";
import DataNotFound from "../Components/Common/DataNotFound";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { BucketURL } from "../ApiSetup/Api";
import dayjs from "dayjs";
import CustomPagination from "../Components/Common/CommonPagination";
import ButtonContained from "../Components/Common/ButtonContained";
import CommonTextField from "../Components/Common/CommonTextField";
import TextLabel from "../Components/Common/CommonTextLabel";
import sessionStoreUtil from "../ApiSetup/Localstorage";
import { useConfirm } from "material-ui-confirm";
import CommonRadioButton from "../Components/Common/CommonRadio";
import { paymentModType } from "../Utils/enum";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { toWords } from "number-to-words";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ButtonOutlined from "../Components/Common/ButtonOutlined";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import PaymentIcon from "@mui/icons-material/Payment";

const OrganisationPayment = () => {
  // ---------- Hook -----------
  const theme = useTheme();
  const dispatch = useDispatch();
  const confirmDialogue = useConfirm();
  const user = sessionStoreUtil.getLSItem("userData")
    ? JSON.parse(sessionStoreUtil.getLSItem("userData"))
    : {};

  // --------------- State -------------
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("");
  const [data, setData] = React.useState();
  const [searchText, setSearchText] = React.useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [isModalOpen, setIsModelOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [_id, set_Id] = useState("");
  const [receiptData, setReceiptData] = useState("");

  // --------------- Api  ---------------
  const _getAllOrganisations = async () => {
    dispatch(showLoader(true));
    try {
      const result = await dispatch(get_all_organisations());
      const error = ErrorHandler(result);
      if (error) {
        setOrganisations(result?.payload?.data?.organisations || []);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _getDocumetsData = async () => {
    dispatch(showLoader(true));
    let body = {
      search: searchText || "",
      page: page,
      limit: rowsPerPage,
      organisationName: selectedOrg || undefined,
    };

    try {
      const result = await dispatch(get_organisation_payment_request(body));
      const error = ErrorHandler(result);
      if (error) {
        setData(result?.payload?.data);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const validation = () => {
    const errors = {};
    let valid = true;
    if (!formData?.id) {
      errors.id = "Please enter Transaction Id.";
      valid = false;
    }
    if (!formData?.amount) {
      errors.amount = "Please enter Amount.";
      valid = false;
    }
    if (!formData?.type) {
      errors.type = "Please select Payment Type.";
      valid = false;
    }
    setErrors(errors);
    return valid;
  };

  const _onClick = async (status, data) => {
    if (status === "Accepted" ? validation() : true) {
      dispatch(showLoader(true));
      let body = {
        _id: data?._id || _id,
        transactionId: formData?.id,
        paymentModeType: status === "Accepted" ? formData?.type : "",
        amount: status === "Accepted" ? Number(formData?.amount) : data?.amount,
        status: status,
      };

      try {
        const result = await dispatch(
          approve_organisation_paymentRequest(body)
        );
        const error = ErrorHandler(result);
        if (error) {
          _getDocumetsData();
          set_Id("");
          toast.success(result?.payload?.message);
          if (status === "Accepted") {
            setFormData({});
            setIsModelOpen(false);
          }
        }
      } catch (error) {
        toast.error(error);
      } finally {
        dispatch(showLoader(false));
      }
    }
  };

  const _get_payment_receipt = async (id) => {
    dispatch(showLoader(true));
    let body = {
      organisationUserId: id,
    };
    try {
      const result = await dispatch(get_payment_receipt(body));
      const error = ErrorHandler(result);
      if (error) {
        const receiptHTML = `<!DOCTYPE html>
<html lang="hi">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Donation Receipt - PPSK</title>
    <link href='https://fonts.googleapis.com/css?family=Poppins' rel='stylesheet'>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Poppins';
        }
        body {
            font-family: 'Arial', sans-serif;
            background-color: #f5f5f5;
            padding: 20px;
        }
        .receipt-container {
            max-width: 100%;
            margin: 0 auto;
            background: white;
            border-radius: 10px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            overflow: hidden;
        }
        .header {
            background: #025864;
            color: white;
            padding: 5px;
            text-align: center;
            position: relative;
            border-bottom: 4px solid rgb(245 52 52);
        }
        .logo-section {
            background: white;
            padding: 8px;
            border-radius: 10px 10px 0 0;
        }
        .logo {
            border-radius: 50%;
            justify-content: center;
            color: white;
            font-weight: bold;
            font-size: 12px;
            text-align: center;
            line-height: 1.2;
        }
        .contact-info {
            line-height: 1.4;
            margin-bottom: 2px;
            margin-top: 10px;
            font-size: 10px;
        }
        .pan-info {
            padding: 8px;
            border-radius: 5px;
            font-weight: bold;
            font-size: 12px;
        }
        .details-section {
            padding: 20px;
            background: white;
        }
        .section-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }
        .section-header h3 {
            color: #1f2937;
            font-size: 14px;
        }
        .date {
            color: black;
            font-size: 14px;
        }
        .date-span {
            font-weight: 600;
        }
        .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 8px 40px;
            margin-bottom: 20px;
        }
        .info-item {
            display: flex;
            flex-direction: flex-start;
            gap: 10px;
        }
        .info-label {
            font-weight: bold;
            color: black;
            font-size: 11px;
            min-width: 120px;
            flex-shrink: 0;
        }
        .info-value {
            color: black;
            font-size: 11px;
            line-height: 1.4;
            flex: 1;
        }
        .amount-section {
            margin: 10px 0;
            border: 1px solid #d1d5db;
            overflow: hidden;
        }
        .amount-header {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            background: #025864;
            color: white;
        }
        .amount-header-cell {
            padding: 8px 20px;
            text-align: center;
            font-size: 12px;
            border-right: 1px solid rgb(245 245 245);
        }
        .amount-values {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            background: white;
        }
        .amount-value-cell {
            padding: 8px 20px;
            text-align: center;
            color: black;
            font-size: 12px;
            border-right: 1px solid #d1d5db;
            text-transform: capitalize;
        }
        .gujarati-section {
            background: #FFF6EF;
            padding: 14px;
            border-radius: 10px;
            margin: 7px 0;
            border: 1px solid #8F0C02;
        }
        .gujarati-title {
            color: #8F0C02;
            font-weight: bold;
            margin-bottom: 3px;
            font-size: 16px;
        }
        .gujarati-text {
            line-height: 1.8;
            color: black;
            margin-bottom: 3px;
            font-size: 10px;
            text-align: justify;
        }
        .signature-section {
            text-align: right;
            margin-top: 8px;
        }
        .signature-line {
            width: 200px;
            height: 44px;
            margin-left: auto;
            border-bottom: 2px solid #374151;
            position: relative;
        }
        .signature-text {
            font-style: italic;
            font-size: 24px;
            color: #6b7280;
            position: absolute;
            bottom: 5px;
            right: 0;
        }
        .signature-label {
            color: #374151;
            font-weight: bold;
            font-size: 10px;
        }
    </style>
</head>
<body>
    <div class="receipt-container">
        <div class="logo-section">
            <div class="logo">
                <img src="/images/headertwo.png" alt="PPSK LOGO" style="height: 8rem;">
            </div>
        </div>
        <div class="header">
            <div class="contact-info">
                એડ્રેસ :- વિભાગ - B, સમસ્ત પાટીદાર સમાજ ટ્રસ્ટ સુરત, શ્રીમતી  એમ.એમ.ખેની ભવન, અંકુર વિદ્યાલયની સામે, આંબાતલાવડી ,કતારગામ -395004,ગુજરાત,ભારત<br>
                મોબાઈલ નંબર :- 9849876476, 9949921021 | Email: info@ppsk.life
            </div>
            <div class="pan-info">
                PAN: AAETS5122K (Income Tax Exemption U/S 80G)
            </div>
        </div>
        <div class="details-section">
            <div class="section-header">
                <h3>Information :</h3>
                <div class="date"><span class="date-span">Date: </span> ${dayjs(result?.payload?.data?.response?.response?.updatedAt).format("ll") || "-"}</div>
            </div>
            <div class="info-grid">
                <div class="info-item">
                    <div class="info-label">Payment By: </div>
                    <div class="info-value">${result?.payload?.data?.response?.response?.name || "-"}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">UTR No: </div>
                    <div class="info-value">52369852</div>
                </div>
                <div class="info-item">
                    <div class="info-label">Verified By: </div>
                    <div class="info-value">${result?.payload?.data?.response?.response?.verifiedBy || "-"}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">ID Proof Type: </div>
                    <div class="info-value">Aadhaar Card</div>
                </div>
                <div class="info-item">
                    <div class="info-label">Mobile Number: </div>
                    <div class="info-value">${result?.payload?.data?.response?.userResponse?.phoneNumber || "-"}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">Aadhaar Card No: </div>
                    <div class="info-value">${result?.payload?.data?.response?.userResponse?.aadharNumber ? result.payload.data.response.userResponse.aadharNumber.replace(/\d(?=\d{4})/g, "X") : '-'}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">Address: </div>
                    <div class="info-value">${result?.payload?.data?.response?.userResponse?.addressDetails?.aadhaarAddress || '-'}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">For Support Fund: </div>
                    <div class="info-value">Donation is given for the<br>Purpose to help Sahaynidhi</div>
                </div>
            </div>
            <div class="amount-section">
                <div class="amount-header">
                    <div class="amount-header-cell">Amount</div>
                    <div class="amount-header-cell">Amount In Words</div>
                    <div class="amount-header-cell">Name of PPSK Members</div>
                </div>
                <div class="amount-values">
                    <div class="amount-value-cell">Rs. ${result?.payload?.data?.response?.response?.amount || "-"} /-</div>
                    <div class="amount-value-cell">${toWords(result?.payload?.data?.response?.response?.amount) || "-"} only</div>
                    <div class="amount-value-cell">
                        ${result?.payload?.data?.response?.response?.userDetails?.map((e) => `<div>${e?.fullName}</div>`).join("")}
                    </div>
                </div>
            </div>
            <div class="gujarati-section">
                <div class="gujarati-title">પ્રતિ,</div>
                <div class="gujarati-text">શ્રી સમસ્ત પાટીદાર સમાજ ટ્રસ્ટ, સુરત</div>
                <div class="gujarati-text">
                    સવિનય સહ,<br>
                    સમાજના સામાજિક અને આર્થિક ઉદ્ઘાન માટે, ખાસ કરીને સમાજના યુવાનોના અકાળે નિધનના સંજોગોમાં તેમના પરિવારને આર્થિક સહાય પહોંચાડવા હેતુથી, આજે હું આ મારું યોગદાન (સહયોગ નિધિ) સ્વીકાર અને સહયોગ સ્વરૂપે આપું છું.
                </div>
                <div class="gujarati-text">
                    આ દાન સંસ્થાના કોર્પસ ફંડ તરીકે મારી સ્વૈચ્છિક સંમતિ સાથે આપવામાં આવે છે, જેનો ઉપયોગ સમાજમાં થતા યુવા ના મૃત્યુના સંજોગોમાં તેમના પરિવારને સહાયમાં કરવામાં આવશે.
                </div>
                <div class="gujarati-text">
                    સંસ્થાના જે નીતિ, નિયમો, બંધારણ અને ભવિષ્યમાં થનાર ઠરાવો હેઠળ હું આ નીતિને સ્વીકારું છું અને તે પ્રમાણે અમલ કરવા માટે પોતાની સંમતિ આપું છું.
                </div>
                <div class="gujarati-text">
                    હું આ બાંહેધરી આપું છું.
                </div>
                <div class="gujarati-text">
                   તમે આ વર્ષે PPSK ની સહાય નિધિ ભરી છે, જેની નોંધ કરવામાં આવી છે. જો તમે દર વર્ષે નિયમિત રીતે 55 વર્ષની ઉંમર સુધી સહાય નિધિ 
         ભરતા રહેશો, તો આપની ગેરહાજરીની સ્થિતિમાં તમારું પરિવાર ₹10 લાખ સુધીની આર્થિક સહાય માટે હકદાર રહેશે.
                </div>
                <a href="${BucketURL}16/04/2025/ppsk_info.pdf"
                   download
                   style="color: #6366f1; text-decoration: underline; cursor: pointer;font-size: 10px;">
                    વધુ માહિતી માટે અહી ક્લિક કરો
                </a>
            </div>
            <div class="signature-section">
                <div class="signature-line">
                    <div class="signature-text">
                      <img class="sign-pic" src="/images/sign.png"  alt="Sign Logo" width="200px" height="50px">
                    </div>
                </div>
                <div class="signature-label">Authorized Signatory</div>
            </div>
        </div>
    </div>
</body>
</html>`;
        setReceiptData(receiptHTML);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      dispatch(showLoader(false));
    }
  };

  const _downloadReceipt = () => {
    const tempContainer = document.createElement("div");
    tempContainer.classList.add("pdf-receipt-wrapper");
    const receiptElement = document.querySelector(".receipt-container");
    if (!receiptElement) {
      console.error("Receipt container not found");
      return;
    }

    const clonedReceipt = receiptElement.cloneNode(true);
    clonedReceipt.classList.add("pdf-receipt");

    const style = document.createElement("style");
    style.innerHTML = `
      .pdf-receipt {
        width: 98% !important;
      }
    `;

    tempContainer.appendChild(style);
    tempContainer.appendChild(clonedReceipt);
    document.body.appendChild(tempContainer);

    html2canvas(tempContainer, { scale: 2, useCORS: true })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        pdf.save("PaymentReceipt.pdf");

        document.body.removeChild(tempContainer);
        setReceiptData("")
      })
      .catch((error) => console.error("Error generating PDF:", error));
  };

  useEffect(() => {
    dispatch(showLoader(true));
    dispatch(getAvailableAccess())
      .unwrap()
      .catch((error) => console.error("error", error))
      .finally(() => dispatch(showLoader(false)));
    _getAllOrganisations();
  }, [dispatch]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  useEffect(() => {
    _getDocumetsData();
  }, [page, rowsPerPage, searchText, selectedOrg]);

  // Calculate summary stats
  const summaryStats = React.useMemo(() => {
    if (!data?.response) return { total: 0, pending: 0, accepted: 0, rejected: 0, totalAmount: 0 };
    
    const stats = data.response.reduce((acc, item) => {
      acc.total++;
      if (item.status === "Pending") acc.pending++;
      else if (item.status === "Accepted") {
        acc.accepted++;
        acc.totalAmount += item.amount || 0;
      }
      else if (item.status === "Rejected") acc.rejected++;
      return acc;
    }, { total: 0, pending: 0, accepted: 0, rejected: 0, totalAmount: 0 });
    
    return stats;
  }, [data]);

  const tableHeaders = [
    "No",
    "Organization Admin",
    "Organization Name",
    "Payment Request",
    "Total Person",
    "Amount",
    "Payment Type",
    "Status",
    user?.organisationName == "PPSK" && "Action",
  ];

  return (
    <>
      <Grid
        container
        spacing={2}
        xs={12}
        sm={12}
        md={12}
        lg={12}
        overflow={"hidden"}
      >
        {/* Summary Tabs */}
        <Grid item xs={12}>
          <Box display="flex" gap={1} flexWrap="wrap">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
              }}
            >
              <BusinessIcon sx={{ fontSize: 20 }} />
              <Typography variant="body2" fontWeight="bold">{organisations.length}</Typography>
              <Typography variant="caption">Total Organisations</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                color: 'white',
              }}
            >
              <PaymentIcon sx={{ fontSize: 20 }} />
              <Typography variant="body2" fontWeight="bold">{summaryStats.pending}</Typography>
              <Typography variant="caption">Pending Requests</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                color: 'white',
              }}
            >
              <PeopleIcon sx={{ fontSize: 20 }} />
              <Typography variant="body2" fontWeight="bold">{summaryStats.accepted}</Typography>
              <Typography variant="caption">Accepted Payments</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 1,
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                color: 'white',
              }}
            >
              <PaymentIcon sx={{ fontSize: 20 }} />
              <Typography variant="body2" fontWeight="bold">₹{summaryStats.totalAmount.toLocaleString()}</Typography>
              <Typography variant="caption">Total Amount Received</Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{ padding: 2, background: { md: "#fff", xs: "none" }, borderRadius: '20px', border: `1px solid lightgrey` }}
          >
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={{ sm: "center", xs: "start" }}
              mb={2}
              gap={2}
              flexDirection={{ sm: "row", xs: "column" }}
            >
              <Typography
                sx={{ fontSize: { lg: 24, md: 20, xs: 18 } }}
                fontWeight={"medium"}
                color={"#3E4094"}
              >
                Organisation Payment Requests
              </Typography>
              <Box display="flex" gap={2} alignItems="center" flexWrap="wrap">
                {/* Organisation Filter */}
                <FormControl size="small" sx={{ minWidth: 200 }}>
                  <Select
                    value={selectedOrg}
                    displayEmpty
                    onChange={(e) => {
                      setSelectedOrg(e.target.value);
                      setPage(1);
                    }}
                  >
                    <MenuItem value="">All Organisations</MenuItem>
                    {organisations.map((org) => (
                      <MenuItem key={org.name} value={org.name}>
                        {org.displayName || org.name} ({org.memberCount})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <CommonSearchField
                  placeholder={"Search.."}
                  tooltipList={["Name", "Organization Name"]}
                  handleSearch={(e) => {
                    setPage(1);
                    setSearchText(e);
                  }}
                />
              </Box>
            </Box>

            <CommonTable
              headerList={tableHeaders}
              align={"center"}
              minWidth={600}
            >
              {data?.response?.length > 0 ? (
                data?.response?.map((document, index) => {
                  return (
                    <TableRow key={index}>
                      <StyledTableCell
                        sx={{
                          position: "relative",
                          padding: "0px",
                          width: "75px",
                        }}
                        align="center"
                      >
                        <Box>{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</Box>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {document?.name || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Chip 
                          label={document?.requestedBy || "-"} 
                          size="small" 
                          color="primary" 
                          variant="outlined"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {dayjs(document?.createdAt).format("ll") || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {document?.userIds?.length || "0"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Typography fontWeight="bold" color="primary">
                          ₹{document?.amount?.toLocaleString() || "0"}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {paymentModType?.filter(
                          (e) => e?.value === document?.paymentModeType
                        )?.[0]?.label || "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CommonChip
                          label={document?.status}
                          status={document?.status}
                        />
                      </StyledTableCell>
                      {document?.status == "Pending" ? (
                        user?.organisationName == "PPSK" ? (
                          <StyledTableCell
                            align="center"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 5,
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              variant="contained"
                              color="success"
                              size="small"
                              onClick={() => {
                                setIsModelOpen(true);
                                set_Id(document?._id);
                                setFormData({
                                  ...formData,
                                  amount: document?.amount
                                })
                              }}
                            >
                              Accept
                            </Button>
                            <Button
                              variant="contained"
                              color="error"
                              size="small"
                              onClick={() => {
                                confirmDialogue({
                                  title: `Are you sure you want to reject?`,
                                  confirmationText: "Yes",
                                  cancellationText: "No",
                                })
                                  .then(() => {
                                    _onClick("Rejected", document);
                                  })
                                  .catch((err) => { });
                              }}
                            >
                              Reject
                            </Button>
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell></StyledTableCell>
                        )
                      ) :
                        document?.status == "Accepted" ? (
                          <StyledTableCell>
                            <Tooltip title="View Payment Receipt">
                              <IconButton
                                sx={{
                                  padding: 0.5, "&:hover": {
                                    border: "1px solid rgba(62, 64, 149, 1)",
                                    background: "rgba(215, 223, 255, 1)",
                                    borderRadius: "10px"
                                  }
                                }}
                                onClick={() =>
                                  _get_payment_receipt(document?._id)
                                }
                              >
                                <VisibilityIcon
                                  fontSize="medium"
                                  color="primary"
                                />
                              </IconButton>
                            </Tooltip>
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell></StyledTableCell>
                        )}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <StyledTableCell colSpan={11}>
                    <DataNotFound
                      title={"No Records Found"}
                      icon={
                        <ErrorOutlineIcon
                          color="primary"
                          style={{ fontSize: "3rem" }}
                        />
                      }
                      elevation={0}
                    />
                  </StyledTableCell>
                </TableRow>
              )}
            </CommonTable>
            {data?.count > 0 && (
              <Grid item xs={12}>
                <CustomPagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  count={Math.ceil(data?.count / rowsPerPage)}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Grid>
            )}
          </Paper>
        </Grid>
      </Grid>

      {/* Accept Payment Modal */}
      <Dialog
        open={isModalOpen}
        onClose={() => {
          setIsModelOpen(false);
          setFormData({});
          set_Id("");
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{"Payment Details"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputLabel
                sx={{
                  letterSpacing: "0.03em",
                  marginRight: "2px",
                  fontSize: "14px",
                  color: "#222222",
                  whiteSpace: "wrap",
                  marginBottom: "0px"
                }}
              >
                Users List
              </InputLabel>
              <Typography>
                {data?.response?.filter((e) => e?._id === _id)?.[0]?.userName?.join(', ')}
              </Typography>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CommonTextField
                value={formData?.id}
                text="Transaction Id"
                placeholder={"Enter Transaction Id"}
                variant="outlined"
                size="small"
                fullWidth
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    id: e?.target?.value,
                  });
                }}
              />
              <TextLabel
                color="error"
                title={!formData?.id ? errors?.id : ""}
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CommonTextField
                value={formData?.amount}
                text="Amount"
                placeholder={"Enter Amount"}
                variant="outlined"
                size="small"
                type={"number"}
                fullWidth
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    amount: e?.target?.value,
                  });
                }}
                disabled
              />
              <TextLabel
                color="error"
                title={!formData?.amount ? errors?.amount : ""}
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CommonRadioButton
                text={"Payment Type"}
                name={"type"}
                options={data?.paymentModeType || []}
                value={formData?.type || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    type: e?.target?.value,
                  })
                }
                valid={true}
              />
              <TextLabel
                color="error"
                title={!formData?.type ? errors?.type : ""}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonContained
            text="Close"
            onClick={() => {
              setIsModelOpen(false);
              setFormData({});
              set_Id("");
            }}
            color="secondary"
          />
          <ButtonContained
            text={"Accept"}
            onClick={() => _onClick("Accepted")}
          />
        </DialogActions>
      </Dialog>

      {/* Receipt Modal */}
      <Dialog
        open={!!receiptData}
        onClose={() => setReceiptData("")}
        fullWidth
        fullScreen
      >
        <DialogTitle
          sx={{
            color: theme?.palette?.primary?.main,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          id="customized-dialog-title"
        >
          {"Payment Receipt Details"}
          <IconButton aria-label="close" onClick={() => setReceiptData("")}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: receiptData }} />
        </DialogContent>
        <DialogActions>
          <ButtonOutlined text="Close" onClick={() => setReceiptData("")} />
          <ButtonContained
            text={"Download"}
            onClick={() => _downloadReceipt()}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OrganisationPayment;
